// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.globalQuickTaskFloating {
  width: 600px;
  max-width: 90vw;
  cursor: grab;
  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.25), 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  animation: slideDown 0.15s ease-out;
}
.globalQuickTaskFloating textarea,
.globalQuickTaskFloating input {
  cursor: text;
}
.globalQuickTaskFloating button {
  cursor: pointer;
}

.globalQuickTaskDragging {
  cursor: grabbing !important;
  -webkit-user-select: none;
          user-select: none;
  animation: none !important;
  box-shadow: 0 12px 32px rgba(59, 130, 246, 0.3), 0 6px 16px rgba(0, 0, 0, 0.2) !important;
}
.globalQuickTaskDragging * {
  cursor: grabbing !important;
}
.globalQuickTaskDragging textarea,
.globalQuickTaskDragging button,
.globalQuickTaskDragging input {
  pointer-events: none;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.globalQuickTaskFloating .globalQuickTaskClose {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  border: none;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.15s ease;
  padding: 0;
  z-index: 10;
}
.globalQuickTaskFloating .globalQuickTaskClose:hover {
  background: #e5e7eb;
  color: #374151;
}
.globalQuickTaskFloating .globalQuickTaskClose:active {
  transform: scale(0.95);
}`, "",{"version":3,"sources":["webpack://./src/components/GlobalQuickTaskModal/GlobalQuickTaskModal.scss"],"names":[],"mappings":"AAKA;EACE,YAAA;EACA,eAAA;EACA,YAAA;EAGA,0FAAA;EAGA,mCAAA;AARF;AAWE;;EAEE,YAAA;AATJ;AAYE;EACE,eAAA;AAVJ;;AAcA;EACE,2BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,0BAAA;EAGA,yFAAA;AAbF;AAeE;EACE,2BAAA;AAbJ;AAiBE;;;EAGE,oBAAA;AAfJ;;AAmBA;EACE;IACE,UAAA;IACA,4BAAA;EAhBF;EAkBA;IACE,UAAA;IACA,wBAAA;EAhBF;AACF;AAqBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,WAAA;AAnBJ;AAqBI;EACE,mBAAA;EACA,cAAA;AAnBN;AAsBI;EACE,sBAAA;AApBN","sourcesContent":["// Global Quick Task Modal\n// Uses TasksApp classes directly - looks EXACTLY like expanded task\n// Draggable, no dark overlay (can see content underneath)\n\n// Floating task - draggable, no overlay\n.globalQuickTaskFloating {\n  width: 600px;\n  max-width: 90vw;\n  cursor: grab;\n  \n  // Extra shadow to make it stand out without dark overlay\n  box-shadow: 0 8px 24px rgba(59, 130, 246, 0.25), 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n  \n  // Animation on first appearance only (not during drag)\n  animation: slideDown 0.15s ease-out;\n  \n  // Keep normal cursors for interactive elements\n  textarea,\n  input {\n    cursor: text;\n  }\n  \n  button {\n    cursor: pointer;\n  }\n}\n\n.globalQuickTaskDragging {\n  cursor: grabbing !important;\n  user-select: none;\n  animation: none !important; // Disable animation during drag\n  \n  // Slightly enhance shadow while dragging\n  box-shadow: 0 12px 32px rgba(59, 130, 246, 0.3), 0 6px 16px rgba(0, 0, 0, 0.2) !important;\n  \n  * {\n    cursor: grabbing !important;\n  }\n  \n  // Disable pointer events on children during drag for performance\n  textarea,\n  button,\n  input {\n    pointer-events: none;\n  }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Close button - positioned absolutely in top-right of the floating modal\n.globalQuickTaskFloating {\n  .globalQuickTaskClose {\n    position: absolute;\n    top: 12px;\n    right: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    border: none;\n    background: transparent;\n    color: #9ca3af;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    padding: 0;\n    z-index: 10;\n    \n    &:hover {\n      background: #e5e7eb;\n      color: #374151;\n    }\n    \n    &:active {\n      transform: scale(0.95);\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
